import * as React from "react";
import {Box} from "@unibuddy/patron";
import {SHOW_UNIVERSITY_INBOX_MESSAGE, SHOW_ASSISTANT_INBOX_MESSAGE} from "shared/constants";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";
import {InboxWrapper} from "./InboxWrapper";
import {UniversityInboxItem} from "./UniversityInboxItem";
import {AssistantInboxItem} from "./AssistantInboxItem";

export const PromotedMessageList: React.FC = () => {
    const showAssistantInboxMessages = useBooleanFeatureFlag(
        SHOW_ASSISTANT_INBOX_MESSAGE.key,
        SHOW_ASSISTANT_INBOX_MESSAGE.value,
    );

    const showUniversityInboxMessages = useBooleanFeatureFlag(
        SHOW_UNIVERSITY_INBOX_MESSAGE.key,
        SHOW_UNIVERSITY_INBOX_MESSAGE.value,
    );

    if (showAssistantInboxMessages) {
        return (
            <Box paddingBottom="small">
                <InboxWrapper>
                    <AssistantInboxItem />
                </InboxWrapper>
            </Box>
        );
    }

    if (!showUniversityInboxMessages) {
        return null;
    }

    return (
        <Box paddingBottom="small">
            <InboxWrapper>
                <UniversityInboxItem />
            </InboxWrapper>
        </Box>
    );
};
